import { useGoToPath } from 'utils/routing/navigation.hooks'

export const useGoToStoreGroupsList = () => useGoToPath('store-groups')

export const useGoToAddStoreGroup = () => useGoToPath('store-groups-add')

export const useGoToEditStoreGroup = (storeGroupId: string) =>
  useGoToPath('store-groups-edit', { storeGroupId })
